// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ev-dash-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 16px;
  font-family: 'Outfit', 'Inter', sans-serif;
  color: #fff;
}

.ev-dash-loader-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  color: #aaa;
}

.ev-dash-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top-color: #9b51e0;
  border-radius: 50%;
  animation: ev-spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes ev-spin {
  to { transform: rotate(360deg); }
}

/* Header Panel styling */
.ev-dash-header-panel {
  background: rgba(14, 27, 27, 0.65);
  backdrop-filter: blur(20px);
  border: 1.5px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 28px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 28px;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.35);
}

.ev-dash-badge {
  display: inline-block;
  background: linear-gradient(135deg, #9b51e0, #48d1cc);
  color: #071414;
  font-size: 10px;
  font-weight: 800;
  padding: 4px 10px;
  border-radius: 20px;
  margin-bottom: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.ev-dash-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px 0;
  background: linear-gradient(120deg, #ffffff, #cbd5e1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.ev-dash-meta {
  font-size: 13.5px;
  color: #cbd5e1;
  margin: 0;
}

.ev-dash-header-panel__right {
  display: flex;
  gap: 16px;
}

.ev-dash-stat-box {
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 14px 22px;
  text-align: center;
  min-width: 130px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
}

.ev-dash-stat-label {
  display: block;
  font-size: 10px;
  color: #8b949e;
  text-transform: uppercase;
  margin-bottom: 4px;
  letter-spacing: 0.8px;
}

.ev-dash-stat-value {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #48d1cc;
  font-family: 'Outfit', sans-serif;
}

/* Tabs System */
.ev-dash-tabs {
  display: flex;
  gap: 12px;
  border-bottom: 1.5px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 24px;
  padding-bottom: 1px;
}

.ev-dash-tab-btn {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14.5px;
  font-weight: 600;
  padding: 12px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.ev-dash-tab-btn:hover {
  color: #ffffff;
}

.ev-dash-tab-btn--active {
  color: #48d1cc;
  font-weight: 700;
}

.ev-dash-tab-btn--active::after {
  content: '';
  position: absolute;
  bottom: -1.5px;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #9b51e0, #48d1cc);
  border-radius: 2px;
}

/* Pane layout */
.ev-dash-pane {
  background: rgba(14, 27, 27, 0.55);
  backdrop-filter: blur(16px);
  border: 1.5px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 28px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
}

.ev-dash-pane__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 16px;
}

.ev-dash-search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 0, 0, 0.45);
  border: 1.5px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 10px 14px;
  width: 100%;
  max-width: 320px;
  transition: border-color 0.2s ease;
}

.ev-dash-search-box:focus-within {
  border-color: #48d1cc;
}

.ev-dash-search-box input {
  background: transparent;
  border: none;
  color: #fff;
  outline: none;
  font-size: 13.5px;
  width: 100%;
}

.ev-dash-search-box input::placeholder {
  color: rgba(255, 255, 255, 0.45);
}

/* Buttons */
.ev-dash-btn {
  font-family: 'Outfit', sans-serif;
  font-size: 13.5px;
  font-weight: 600;
  padding: 10px 16px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.25s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.ev-dash-btn--export {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #fff;
}

.ev-dash-btn--export:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.2);
}

.ev-dash-btn--danger-sm {
  background: rgba(255, 107, 107, 0.1);
  border: 1px solid rgba(255, 107, 107, 0.25);
  color: #ff6b6b;
  font-size: 12px;
  padding: 6px 12px;
}

.ev-dash-btn--danger-sm:hover {
  background: rgba(255, 107, 107, 0.25);
  color: #fff;
}

.ev-dash-btn--danger {
  background: linear-gradient(135deg, #d32f2f, #ff5252);
  color: #fff;
  font-size: 14.5px;
  padding: 12px 24px;
}

.ev-dash-btn--danger:hover {
  box-shadow: 0 0 15px rgba(255, 82, 82, 0.4);
  transform: translateY(-1px);
}

.ev-dash-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ev-dash-btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-top-color: currentColor;
  border-radius: 50%;
  animation: ev-spin 0.8s linear infinite;
}

/* Tables styling */
.ev-dash-table-wrapper {
  overflow-x: auto;
}

.ev-dash-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 13.5px;
}

.ev-dash-table th {
  padding: 16px 20px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  font-weight: 700;
  text-transform: uppercase;
  font-size: 11.5px;
  letter-spacing: 0.8px;
  font-family: 'Outfit', sans-serif;
}

.ev-dash-table td {
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  vertical-align: middle;
  color: #e6edf3;
}

.ev-dash-table tbody tr {
  transition: background-color 0.2s ease;
}

.ev-dash-table tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.02);
}

.ev-dash-row--cancelled {
  opacity: 0.45;
  background-color: rgba(255, 0, 0, 0.02);
}

.ev-dash-table-empty {
  text-align: center;
  padding: 40px 0 !important;
  color: #666;
  font-style: italic;
}

.ev-badge-status {
  font-size: 10.5px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
}

.ev-badge-status--registered {
  background-color: rgba(72, 209, 204, 0.15);
  color: #48d1cc;
  border: 1px solid rgba(72, 209, 204, 0.25);
}

.ev-badge-status--waitlisted {
  background-color: rgba(255, 204, 0, 0.15);
  color: #ffcc00;
  border: 1px solid rgba(255, 204, 0, 0.25);
}

.ev-badge-status--cancelled {
  background-color: rgba(255, 107, 107, 0.15);
  color: #ff6b6b;
  border: 1px solid rgba(255, 107, 107, 0.25);
}

.ev-dash-reqs-text {
  max-width: 180px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Waitlist styling */
.ev-dash-waitlist-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}

.ev-waitlist-card {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 16px;
  gap: 16px;
}

.ev-waitlist-card__pos {
  font-size: 20px;
  font-weight: 800;
  color: #ffcc00;
  min-width: 40px;
  text-align: center;
}

.ev-waitlist-card__details {
  flex: 1 1;
}

.ev-waitlist-card__details h4 {
  margin: 0 0 4px 0;
  font-size: 15px;
  font-weight: 600;
}

.ev-waitlist-card__details p {
  margin: 0;
  font-size: 12px;
  color: #666;
}

.ev-dash-pane-empty {
  text-align: center;
  padding: 40px 20px;
  color: #666;
}

.ev-dash-pane-empty h4 {
  color: #aaa;
  margin: 12px 0 6px 0;
}

.ev-dash-pane-empty p {
  margin: 0;
  font-size: 13px;
}

/* Form Settings */
.ev-dash-cancel-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ev-dash-form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ev-dash-form-group label {
  font-size: 13px;
  color: #aaa;
  font-weight: 500;
}

.ev-dash-form-group textarea {
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 12px;
  color: #fff;
  height: 120px;
  resize: none;
  font-family: inherit;
  font-size: 13.5px;
  outline: none;
}

.ev-dash-form-group textarea:focus {
  border-color: #ff6b6b;
}

.ev-char-count {
  font-size: 11px;
  color: #555;
  text-align: right;
}

.ev-required {
  color: #ff6b6b;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/EventDashboardPage/EventDashboardPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,yBAAyB;AACzB;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,6CAA6C;EAC7C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;EACrB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,oDAAoD;EACpD,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,6CAA6C;EAC7C,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,6CAA6C;EAC7C,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA,YAAY;AACZ;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,8BAA8B;EAC9B,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".ev-dash-container {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 16px;\n  font-family: 'Outfit', 'Inter', sans-serif;\n  color: #fff;\n}\n\n.ev-dash-loader-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  color: #aaa;\n}\n\n.ev-dash-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(255, 255, 255, 0.1);\n  border-top-color: #9b51e0;\n  border-radius: 50%;\n  animation: ev-spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes ev-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Header Panel styling */\n.ev-dash-header-panel {\n  background: rgba(14, 27, 27, 0.65);\n  backdrop-filter: blur(20px);\n  border: 1.5px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  padding: 28px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-bottom: 28px;\n  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.35);\n}\n\n.ev-dash-badge {\n  display: inline-block;\n  background: linear-gradient(135deg, #9b51e0, #48d1cc);\n  color: #071414;\n  font-size: 10px;\n  font-weight: 800;\n  padding: 4px 10px;\n  border-radius: 20px;\n  margin-bottom: 12px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.ev-dash-title {\n  font-size: 28px;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  background: linear-gradient(120deg, #ffffff, #cbd5e1);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.ev-dash-meta {\n  font-size: 13.5px;\n  color: #cbd5e1;\n  margin: 0;\n}\n\n.ev-dash-header-panel__right {\n  display: flex;\n  gap: 16px;\n}\n\n.ev-dash-stat-box {\n  background: rgba(0, 0, 0, 0.35);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 14px 22px;\n  text-align: center;\n  min-width: 130px;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.ev-dash-stat-label {\n  display: block;\n  font-size: 10px;\n  color: #8b949e;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n  letter-spacing: 0.8px;\n}\n\n.ev-dash-stat-value {\n  display: block;\n  font-size: 20px;\n  font-weight: 700;\n  color: #48d1cc;\n  font-family: 'Outfit', sans-serif;\n}\n\n/* Tabs System */\n.ev-dash-tabs {\n  display: flex;\n  gap: 12px;\n  border-bottom: 1.5px solid rgba(255, 255, 255, 0.08);\n  margin-bottom: 24px;\n  padding-bottom: 1px;\n}\n\n.ev-dash-tab-btn {\n  background: transparent;\n  border: none;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 14.5px;\n  font-weight: 600;\n  padding: 12px 20px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.ev-dash-tab-btn:hover {\n  color: #ffffff;\n}\n\n.ev-dash-tab-btn--active {\n  color: #48d1cc;\n  font-weight: 700;\n}\n\n.ev-dash-tab-btn--active::after {\n  content: '';\n  position: absolute;\n  bottom: -1.5px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #9b51e0, #48d1cc);\n  border-radius: 2px;\n}\n\n/* Pane layout */\n.ev-dash-pane {\n  background: rgba(14, 27, 27, 0.55);\n  backdrop-filter: blur(16px);\n  border: 1.5px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  padding: 28px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);\n}\n\n.ev-dash-pane__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.ev-dash-search-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(0, 0, 0, 0.45);\n  border: 1.5px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  padding: 10px 14px;\n  width: 100%;\n  max-width: 320px;\n  transition: border-color 0.2s ease;\n}\n\n.ev-dash-search-box:focus-within {\n  border-color: #48d1cc;\n}\n\n.ev-dash-search-box input {\n  background: transparent;\n  border: none;\n  color: #fff;\n  outline: none;\n  font-size: 13.5px;\n  width: 100%;\n}\n\n.ev-dash-search-box input::placeholder {\n  color: rgba(255, 255, 255, 0.45);\n}\n\n/* Buttons */\n.ev-dash-btn {\n  font-family: 'Outfit', sans-serif;\n  font-size: 13.5px;\n  font-weight: 600;\n  padding: 10px 16px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ev-dash-btn--export {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #fff;\n}\n\n.ev-dash-btn--export:hover {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.ev-dash-btn--danger-sm {\n  background: rgba(255, 107, 107, 0.1);\n  border: 1px solid rgba(255, 107, 107, 0.25);\n  color: #ff6b6b;\n  font-size: 12px;\n  padding: 6px 12px;\n}\n\n.ev-dash-btn--danger-sm:hover {\n  background: rgba(255, 107, 107, 0.25);\n  color: #fff;\n}\n\n.ev-dash-btn--danger {\n  background: linear-gradient(135deg, #d32f2f, #ff5252);\n  color: #fff;\n  font-size: 14.5px;\n  padding: 12px 24px;\n}\n\n.ev-dash-btn--danger:hover {\n  box-shadow: 0 0 15px rgba(255, 82, 82, 0.4);\n  transform: translateY(-1px);\n}\n\n.ev-dash-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ev-dash-btn-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-top-color: currentColor;\n  border-radius: 50%;\n  animation: ev-spin 0.8s linear infinite;\n}\n\n/* Tables styling */\n.ev-dash-table-wrapper {\n  overflow-x: auto;\n}\n\n.ev-dash-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n  font-size: 13.5px;\n}\n\n.ev-dash-table th {\n  padding: 16px 20px;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 700;\n  text-transform: uppercase;\n  font-size: 11.5px;\n  letter-spacing: 0.8px;\n  font-family: 'Outfit', sans-serif;\n}\n\n.ev-dash-table td {\n  padding: 16px 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  vertical-align: middle;\n  color: #e6edf3;\n}\n\n.ev-dash-table tbody tr {\n  transition: background-color 0.2s ease;\n}\n\n.ev-dash-table tbody tr:hover {\n  background-color: rgba(255, 255, 255, 0.02);\n}\n\n.ev-dash-row--cancelled {\n  opacity: 0.45;\n  background-color: rgba(255, 0, 0, 0.02);\n}\n\n.ev-dash-table-empty {\n  text-align: center;\n  padding: 40px 0 !important;\n  color: #666;\n  font-style: italic;\n}\n\n.ev-badge-status {\n  font-size: 10.5px;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.ev-badge-status--registered {\n  background-color: rgba(72, 209, 204, 0.15);\n  color: #48d1cc;\n  border: 1px solid rgba(72, 209, 204, 0.25);\n}\n\n.ev-badge-status--waitlisted {\n  background-color: rgba(255, 204, 0, 0.15);\n  color: #ffcc00;\n  border: 1px solid rgba(255, 204, 0, 0.25);\n}\n\n.ev-badge-status--cancelled {\n  background-color: rgba(255, 107, 107, 0.15);\n  color: #ff6b6b;\n  border: 1px solid rgba(255, 107, 107, 0.25);\n}\n\n.ev-dash-reqs-text {\n  max-width: 180px;\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Waitlist styling */\n.ev-dash-waitlist-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.ev-waitlist-card {\n  display: flex;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n  padding: 16px;\n  gap: 16px;\n}\n\n.ev-waitlist-card__pos {\n  font-size: 20px;\n  font-weight: 800;\n  color: #ffcc00;\n  min-width: 40px;\n  text-align: center;\n}\n\n.ev-waitlist-card__details {\n  flex: 1;\n}\n\n.ev-waitlist-card__details h4 {\n  margin: 0 0 4px 0;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.ev-waitlist-card__details p {\n  margin: 0;\n  font-size: 12px;\n  color: #666;\n}\n\n.ev-dash-pane-empty {\n  text-align: center;\n  padding: 40px 20px;\n  color: #666;\n}\n\n.ev-dash-pane-empty h4 {\n  color: #aaa;\n  margin: 12px 0 6px 0;\n}\n\n.ev-dash-pane-empty p {\n  margin: 0;\n  font-size: 13px;\n}\n\n/* Form Settings */\n.ev-dash-cancel-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.ev-dash-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ev-dash-form-group label {\n  font-size: 13px;\n  color: #aaa;\n  font-weight: 500;\n}\n\n.ev-dash-form-group textarea {\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  padding: 12px;\n  color: #fff;\n  height: 120px;\n  resize: none;\n  font-family: inherit;\n  font-size: 13.5px;\n  outline: none;\n}\n\n.ev-dash-form-group textarea:focus {\n  border-color: #ff6b6b;\n}\n\n.ev-char-count {\n  font-size: 11px;\n  color: #555;\n  text-align: right;\n}\n\n.ev-required {\n  color: #ff6b6b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
